import { LockSimple, Sparkle, Waves } from '@phosphor-icons/react';

import { sumBucketAmount } from '../../lib/incomeSourceBuckets';
import { formatEUR } from '../../utils/money';
import { cn } from '../../utils/cn';
import { IncomeSourceRow } from './IncomeSourceRow';
import pt from '../../locales/pt';

const BUCKET_ICONS = {
  guaranteed: LockSimple,
  variable: Waves,
  occasional: Sparkle,
};

/**
 * Cartão de grupo — `.pen` `ds/card/composition-group` (`LCiBo`), cabeçalho
 * com chip de ícone + nome + total, separador, e linhas de fontes.
 */
export function IncomeSourceBucketGroup({ bucket, sources, onEdit, onArchive }) {
  const Icon = BUCKET_ICONS[bucket.id] || Sparkle;

  return (
    <section className="overflow-hidden rounded-ds-lg border border-border bg-card">
      <div className="flex items-center justify-between gap-space-3 px-space-5 py-space-4">
        <div className="flex items-center gap-space-2">
          <span
            className={cn(
              'flex h-6 w-6 shrink-0 items-center justify-center rounded-ds-sm',
              bucket.tone.chipBg,
            )}
          >
            <Icon className={cn('h-3.5 w-3.5', bucket.tone.chipFg)} aria-hidden />
          </span>
          <h3 className="type-title-card text-card-foreground">
            {pt.income.sources.buckets[bucket.labelKey]}
          </h3>
        </div>
        <span className="type-display-stat text-card-foreground">
          {formatEUR(sumBucketAmount(sources))}
        </span>
      </div>
      <div className="h-px w-full bg-border" />
      <ul className="flex flex-col px-space-5 pb-space-4">
        {sources.map((source, index) => (
          <li key={source.id} className="list-none">
            <IncomeSourceRow source={source} isFirst={index === 0} onEdit={onEdit} onArchive={onArchive} />
          </li>
        ))}
      </ul>
    </section>
  );
}
